// UI strings for the supporter profile page (chrome around the per-supporter
// data in src/data/supporters.ts).

import { type Locale } from "../config";

type ProfileStrings = {
  backToAll: string;
  eyebrow: string;
  ctaHeading: string;
  ctaBody: string;
  ctaButton: string;
  othersHeading: string;
  notFoundHeading: string;
  backToOverview: string;
  errorHeading: string;
  errorBody: string;
};

export const jobsUrl = "https://misupport.career.emply.com/da/ledige-stillinger";

export const profileStrings: Record<Locale, ProfileStrings> = {
  da: {
    backToAll: "Tilbage til alle MI Supportere",
    eyebrow: "Mød en MI Supporter",
    ctaHeading: "Er du vores nye kollega?",
    ctaBody:
      "I MI Support er vi altid på udkig efter nye, dygtige kollegaer, der har lyst til at blive en del af vores team. Vi tilbyder engagerede kollegaer med fokus på udvikling og faglig sparring, og et rart arbejdsmiljø med hyppige sociale arrangementer.",
    ctaButton: "Se vores jobmuligheder",
    othersHeading: "Mød flere af vores konsulenter",
    notFoundHeading: "Profil ikke fundet",
    backToOverview: "Tilbage til oversigten",
    errorHeading: "Noget gik galt",
    errorBody: "Der opstod en uventet fejl. Prøv igen.",
  },
  en: {
    backToAll: "Back to all MI Supporters",
    eyebrow: "Meet a MI Supporter",
    ctaHeading: "Are you our new colleague?",
    ctaBody:
      "At MI Support we are always looking for new, talented colleagues who want to become part of our team. We offer engaged colleagues with a focus on development and professional sparring, and a pleasant working environment with frequent social events.",
    ctaButton: "See our job opportunities",
    othersHeading: "Meet more of our consultants",
    notFoundHeading: "Profile not found",
    backToOverview: "Back to the overview",
    errorHeading: "Something went wrong",
    errorBody: "An unexpected error occurred. Please try again.",
  },
  de: {
    backToAll: "Zurück zu allen MI Supportern",
    eyebrow: "Treffen Sie einen MI Supporter",
    ctaHeading: "Bist du unser neuer Kollege?",
    ctaBody:
      "Bei MI Support suchen wir immer nach neuen, talentierten Kollegen, die Teil unseres Teams werden möchten. Wir bieten engagierte Kollegen mit Fokus auf Entwicklung und fachlichen Austausch sowie ein angenehmes Arbeitsumfeld mit regelmäßigen sozialen Veranstaltungen.",
    ctaButton: "Sieh dir unsere Stellenangebote an",
    othersHeading: "Lernen Sie weitere unserer Berater kennen",
    notFoundHeading: "Profil nicht gefunden",
    backToOverview: "Zurück zur Übersicht",
    errorHeading: "Etwas ist schiefgelaufen",
    errorBody: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  },
};
